export const text = {
  login: 'Sign Up',
  pageTitle: 'Sign Up',
};
